module.exports = __webpack_public_path__ + "img/matt-violet.4e2eff20.png";